import { Field, PolygonType } from "#models/questionnaire";
import { isGoogleGeometryLoaded } from "#utils/googleMaps";
import { polygonValid } from "#utils/polygonValid";
import { FieldValidator, useField } from 'formik';
import * as React from 'react';

export const useAddressField = (field: Field, questionLocation: PolygonType[][]) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let validateFunc: FieldValidator = () => {};

  validateFunc = (value: any) => {
    if (questionLocation.length && value) {
      // Without the Maps script we cannot test the service area. Let the lead through
      // rather than blanking the form or rejecting every address.
      if (!isGoogleGeometryLoaded()) {
        console.error('Google Maps unavailable - skipping service area validation');
        return '';
      }
      const addressValue = new google.maps.LatLng(value);
      let checkLocation = polygonValid(questionLocation, addressValue);
      if (!checkLocation) {
        return 'Sorry, our service is not available in your area';
      }
    }
    return '';
  };

  const [{ value: questionFieldSubmissions = [] }] = useField('questionFieldSubmissions');
  const fieldIndex = React.useMemo(
    () => questionFieldSubmissions.findIndex((f: any) => f.fieldId === field.id),
    [questionFieldSubmissions]
  );

  return useField({
    name: `questionFieldSubmissions.[${fieldIndex}].location`,
    validate: validateFunc
  });
};
